import styled, { keyframes } from "styled-components";
import { getThemeMedia } from "../helpers";
const toastMediumEnter = keyframes `
	from {
		transform: translateY(-100%);
		opacity: 0;
	}

	to {
		transform: translateY(0%);
		opacity: 1;
	}
	`;
const toastMediumLeave = keyframes `
	from {
		opacity: 1;
		transform: translateY(0%);
	}

	to {
		opacity: 0;
		transform: translateY(-100%);
	}
`;
const toastSmallEnter = keyframes `
	from {
		transform: translateY(100%);
		opacity: 0;
	}

	to {
		transform: translateY(0%);
		opacity: 1;
	}
`;
const toastSmallLeave = keyframes `
	from {
		opacity: 1;
		transform: translateY(0%);
	}

	to {
		opacity: 0;
		transform: translateY(100%);
	}
`;
export const AnimationWrapper = styled.div `
	width: 100%;

	animation-duration: 300ms;
	animation-fill-mode: forwards;
	animation-timing-function: linear;
	animation-name: ${({ visible }) => (visible ? toastSmallEnter : toastSmallLeave)};

	@media screen {
		@media (min-width: ${getThemeMedia("medium")}) {
			animation-name: ${({ visible }) => (visible ? toastMediumEnter : toastMediumLeave)};
		}
	}
`;
//# sourceMappingURL=styles.js.map